export default "__VITE_ASSET__c31c078e__"